import React, { useEffect, useState } from "react";
import axios from "axiosPaymentClient";
import { useParams } from "react-router-dom";
import { Row, Col } from "reactstrap";
import moment from "moment";
import { QRCodeSVG } from "qrcode.react";

// Assuming you have logos in your assets
import logoLeft from "assets/logos/cambridge.png";
import logoCenter from "assets/logos/edu.png";
import logoRight from "assets/logos/ielts.png";

const PaymentPrint = () => {
  const { id } = useParams();
  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/api/docs/${id}`)
      .then((result) => {
        setPayment(result.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching payment details:", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!payment) {
    return <div>Payment not found.</div>;
  }

  return (
    <div
      style={{
        width: "210mm",
        height: "297mm",
        margin: "auto",
        fontFamily: "Times New Roman",
        backgroundColor: "#ffffff",
      }}
      className="p-5 bg-white my-3"
    >
      <div id="payment-print-root">
        <Row className="mb-5">
          <Col xs="4" className="text-left">
            <img
              src={logoLeft}
              alt="Left Logo"
              style={{ height: "80px", paddingLeft: "30px" }}
            />
          </Col>
          <Col xs="4" className="text-center">
            <img
              src={logoCenter}
              alt="Center Logo"
              style={{ height: "80px", paddingLeft: "30px" }}
            />
          </Col>
          <Col xs="4" className="text-right">
            <img
              src={logoRight}
              alt="Right Logo"
              style={{ height: "80px", paddingRight: "30px" }}
            />
          </Col>
        </Row>

        <div className="text-center my-5">
          <h5 className="text-left ml-4 pt-3">
            № {payment.number} от{" "}
            {moment(payment.createdAt).format("DD/MM/YYYY")}
          </h5>
          <h4 className="text-bold mt-5" style={{ fontSize: "1.5rem" }}>
            М а ъ л у м о т н о м а
          </h4>
        </div>

        <div className="text-center my-5" style={{ fontSize: "1.1rem" }}>
          OOO “Edu-Action” IELTS Test маркази тасдиклайди.
        </div>

        <table
          className="table table-bordered w-100 my-5"
          style={{ border: "1px solid #000" }}
        >
          <tbody style={{ fontSize: "1rem" }}>
            <tr>
              <td>Исм Шарифи</td>
              <td>
                <b>{`${payment.candidateName}`}</b>
              </td>
            </tr>
            <tr>
              <td>Паспорт №</td>
              <td>
                <b>{payment.passportNo}</b>
              </td>
            </tr>
            <tr>
              <td>Тулов куни</td>
              <td>
                <b>{payment.paymentDate}</b>
              </td>
            </tr>
            <tr>
              <td>Тулов суммаси</td>
              <td>
                <b>
                  {new Intl.NumberFormat("ru-RU").format(payment.paymentAmount)}
                </b>
              </td>
            </tr>
            <tr>
              <td>Имтихон топширган куни</td>
              <td>
                <b>{payment.examDate}</b>
              </td>
            </tr>
          </tbody>
        </table>

        <Row className="d-flex align-items-center mt-3">
          <Col xs="4" className="text-medium">
            <p>{payment.signTitle}</p>
          </Col>
          <Col xs="4" className="text-center">
            <QRCodeSVG
              value={`https://payment.edu-action.uk/doc-verification/${payment.number}`}
              size={128}
              bgColor={"#ffffff"}
              fgColor={"#ff6c1c"}
              level={"L"}
              includeMargin={true}
            />
          </Col>
          <Col xs="4" className="text-medium">
            <p>{payment.signName}</p>
          </Col>
        </Row>
        <p style={window.innerWidth < 480 ? { lineHeight: "0.7rem" } : {}}>
          QR кодни сканерлаш орқали тўлов ҳақидаги маълумотларни текширишингиз
          мумкин.
        </p>
        <p style={{ fontSize: "10px", lineHeight: "0.8rem" }}>
          OOO “Edu Action” <br />
          Р/С: 20208000905333707001 БАНК: AITB «IPAK YOLI» MIROBOD FILIALI{" "}
          <br /> МФО: 01101 ИНН: 307858754 ТЕЛ: (+998 95)1458686 <br />
          Г.ТАШКЕНТ, УЛ.БУНЁДКОР,ДОМ-3А, ИНДЕКС 100043
        </p>
      </div>
    </div>
  );
};

export default PaymentPrint;
